module.exports = __webpack_public_path__ + "img/non_profile.a41578c7.png";